export default __webpack_public_path__ + "4701e2e23454f6ce9df093c703a7ddb1.png";